/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ListItem, { IListItemProps } from "@atg/icf-react-components/components/ListItem";
import ITheme from "@atg/icf-react-components/themes/Theme";
import { FC } from "react";
import { createUseStyles } from "react-jss";

import { JSS_MEDIA_MOBILE_MAX, JSS_MEDIA_TABLET_MAX } from "~/constants";
import useOnLanding from "~/hooks/useOnLanding";

interface StyleProps {
  onLanding: boolean;
  disabled: boolean;
}

const useStyles = createUseStyles<string, StyleProps, ITheme>((theme) => ({
  listItem: {
    padding: 0,
    "& a": {
      color: (props) => (props.disabled ? theme.colors.baseContrast030 : theme.colors.baseContrast080),
      padding: [0, theme.spacing.base],
    },
    "&:hover": {
      background: theme.colors.baseContrast020,
    },
    [JSS_MEDIA_MOBILE_MAX]: {
      "& a": {
        // eslint-disable-next-line @atg/css-rtl-support
        paddingLeft: theme.spacing.base * 3,
      },
      "&:hover": {
        background: "none",
      },
    },
    [JSS_MEDIA_TABLET_MAX]: {
      "&:hover": {
        background: (props) => (props.onLanding ? "none" : ""),
      },
    },
  },
}));

const SubMenuItem: FC<IListItemProps> = ({ disabled = false, children, ...rest }) => {
  const onLanding = useOnLanding();
  const classes = useStyles({ onLanding, disabled });

  return (
    <ListItem overrides={{ root: classes.listItem }} disabled={disabled} {...rest}>
      {children}
    </ListItem>
  );
};

export default SubMenuItem;
